import { AxiosResponse } from 'axios';
import ApiService, { ApiArguments } from '@/api/api_service';
import {
  CustomDefaultLeadViewSettingApi,
  GetCustomDefaultLeadViewSetting200Response,
  CustomDefaultLeadViewSettingApiPutCustomDefaultLeadViewSettingRequest,
} from '@/api/openapi';

export class CustomDefaultLeadViewSettingApiService extends ApiService {
  api = new CustomDefaultLeadViewSettingApi(undefined, this.baseUrl, this.httpInstance);

  constructor() {
    super(true);
  }

  async getCustomDefaultLeadViewSetting(
    apiArguments?: ApiArguments<undefined>,
  ): Promise<AxiosResponse<GetCustomDefaultLeadViewSetting200Response>> {
    return this.checkResponse<GetCustomDefaultLeadViewSetting200Response>(
      this.api.getCustomDefaultLeadViewSetting(apiArguments?.options),
      apiArguments?.errorHandlers,
    );
  }

  async putCustomDefaultLeadViewSetting({
    request,
    options,
    errorHandlers,
  }: ApiArguments<CustomDefaultLeadViewSettingApiPutCustomDefaultLeadViewSettingRequest>): Promise<AxiosResponse<GetCustomDefaultLeadViewSetting200Response>> {
    return this.checkResponse<GetCustomDefaultLeadViewSetting200Response>(
      this.api.putCustomDefaultLeadViewSetting(request, options),
      errorHandlers,
    );
  }
}
